var _a;
import { Facility_Location_Type } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Facility_Location_Type.AmbulatorySurgeryCenter] = 'Ambulatory Surgery Center',
    _a[Facility_Location_Type.AssistedLivingFacility] = 'Assisted Living Facility',
    _a[Facility_Location_Type.Clinic] = 'Clinic',
    _a[Facility_Location_Type.ClinicDental] = 'Clinic - Dental',
    _a[Facility_Location_Type.ClinicVision] = 'Clinic - Vision',
    _a[Facility_Location_Type.DialysisCenter] = 'Dialysis Center',
    _a[Facility_Location_Type.EmergencyRoom] = 'Emergency Room',
    _a[Facility_Location_Type.HomeHealthAgency] = 'Home Health Agency',
    _a[Facility_Location_Type.Hospice] = 'Hospice',
    _a[Facility_Location_Type.Hospital] = 'Hospital',
    _a[Facility_Location_Type.HospitalChildrenChronicDisease] = 'Hospital - Children Chronic Disease',
    _a[Facility_Location_Type.HospitalChildrenGeneralAcuteCare] = 'Hospital - Children General Acute Care',
    _a[Facility_Location_Type.HospitalChildrenRehabilitation] = 'Hospital - Children Rehabilitation',
    _a[Facility_Location_Type.HospitalChronicDisease] = 'Hospital - Chronic Disease',
    _a[Facility_Location_Type.HospitalGeneralAcuteCare] = 'Hospital - General Acute Care',
    _a[Facility_Location_Type.HospitalLongTermCare] = 'Hospital - Long Term Care',
    _a[Facility_Location_Type.HospitalPsychiatric] = 'Hospital - Psychiatric',
    _a[Facility_Location_Type.HospitalRehabilitation] = 'Hospital - Rehabilitation',
    _a[Facility_Location_Type.ImagingCenter] = 'Imaging Center',
    _a[Facility_Location_Type.IndependentClinic] = 'Independent Clinic',
    _a[Facility_Location_Type.LaboratoryDental] = 'Laboratory - Dental',
    _a[Facility_Location_Type.LaboratoryMedical] = 'Laboratory - Medical',
    _a[Facility_Location_Type.LaboratoryPhysiological] = 'Laboratory - Physiological',
    _a[Facility_Location_Type.Pharmacy] = 'Pharmacy',
    _a[Facility_Location_Type.PhysicalTherapy] = 'Physical Therapy',
    _a[Facility_Location_Type.PrimaryCareClinic] = 'Primary Care Clinic',
    _a[Facility_Location_Type.ResidentialTreatmentFacilityMentalOrDevelopmentalDisabilities] = 'Residential Treatment Facility - Mental or Developmental Disabilities',
    _a[Facility_Location_Type.ResidentialTreatmentFacilityPhysicalDisabilities] = 'Residential Treatment Facility - Physical Disabilities',
    _a[Facility_Location_Type.ResidentialTreatmentFacilityPsychiatric] = 'Residential Treatment Facility - Psychiatric',
    _a[Facility_Location_Type.ResidentialTreatmentFacilitySubstanceAbuse] = 'Residential Treatment Facility - Substance Abuse',
    _a[Facility_Location_Type.RespiteCare] = 'Respite Care',
    _a[Facility_Location_Type.RetailHealthClinic] = 'Retail Health Clinic',
    _a[Facility_Location_Type.SkilledNursingFacility] = 'Skilled Nursing Facility',
    _a[Facility_Location_Type.SkilledNursingFacilityPediatric] = 'Skilled Nursing Facility - Pediatric',
    _a[Facility_Location_Type.Telemedicine] = 'Telemedicine',
    _a[Facility_Location_Type.UrgentCare] = 'Urgent Care',
    _a);
export var FacilityLocationTypeEnum = {
    name: 'Facility_Location_Type',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
